import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from "yup";
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FormField from '../layout/FormField';

const ResetPassword = () => {
  const validate = Yup.object({
    email: Yup.string().email("Email is invalid").required("Required"),
    password: Yup.string().required("Required"),
  })
    return (
        <div className="p-5 form_container mx-auto">
            <div className="heading mb-3 text-center">
                <h3>Reset Password</h3>
            </div>
            <Formik
            initialValues={{
              email: "",
              password: ""
            }}
            validationSchema={validate}
            onSubmit={
              (values)=> {
                console.log("signin", values)
              }
            }
            >
                <Form>
                    <FormField label="Password" name="password" type="password" />                    
                    <FormField label="Retpye Password" name="retype_password" type="password" />                    
                    <div className="d-grid gap-2">
                        <Button type="submit" className="theme-btn mb-3">
                            Reset
                        </Button>
                        <Link to="/signup" className="d-grid text-start text-dark">Back to Login</Link>
                    </div>
                </Form>
            </Formik>
        </div>
    );
};

export default ResetPassword;
